/* RESPONSIBLE TEAM: team-frontend-tech */
import SubviewSerializer from './subview';

export default SubviewSerializer;
